import { render, staticRenderFns } from "./NavbarBusinessPhone.vue?vue&type=template&id=d69ee966&scoped=true&"
import script from "./NavbarBusinessPhone.vue?vue&type=script&lang=js&"
export * from "./NavbarBusinessPhone.vue?vue&type=script&lang=js&"
import style0 from "./NavbarBusinessPhone.vue?vue&type=style&index=0&id=d69ee966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69ee966",
  null
  
)

export default component.exports